<template>
  <section
    v-show="isActive"
    :id="hash"
    :aria-hidden="! isActive"
    class="tabs-component-panel"
    role="tabpanel"
  >
    <slot v-if="isActive" />
  </section>
</template>

<script>
export default {
  props: {
    href: { default: '#' },
    id: { default: null },
    name: { required: true },
    prefix: { default: '' },
    suffix: { default: '' },
    isDisabled: { default: false },
    isVisible: { default: true }
  },

  data: () => ({
    isActive: false
  }),

  computed: {
    header () {
      return this.prefix + this.name + this.suffix
    },

    hash () {
      if (this.isDisabled) {
        return ''
      }
      return this.href ? this.href : this.name.toLowerCase().replace(/ /g, '-')
    }
  }
}
</script>
